import BaseService from "@/service/base"

import { index, news } from "@/enums/interfaceEnum"

import { Config } from "@/utils/service/http"
import { ServiceReturnType } from "#/net"
import { PLATFORM } from "@/config/service"

export type Banner = {
  id: number
  /**
   * 标题
   */
  title: string
  /**
   * 图片
   */
  image: string
  /**
   * 排序
   */
  sort: number
  /**
   * 跳转链接
   */
  jump_url: string
}

export default class IndexService extends BaseService {
  /**
   * 获取banner列表
   */
  static getBannerList(config?: Config) {
    return this.get<Array<Banner>>(index.BANNER_LIST, { platform: PLATFORM }, { needToken: false, ...config })
  }

  /**
   * 获取资讯详情
   */
  static getNewInfo(payload: { id: string }, config?: Config) {
    return this.get(news.GET_NEWS_INFO, payload, { needToken: false, ...config })
  }

  /**
   * 获取资讯列表
   */
  static getNewList(payload = { page: 1, type: 1 }, config?: Config) {
    return this.get(news.GET_NEWS_LIST, { ...payload, platform: PLATFORM }, { needToken: false, ...config })
  }

  /**
   * 获取直播列表
   */
  static getLiveList(payload = { page: 1, type: 2 }, config?: Config) {
    return this.get(index.LIVE_LIST, { ...payload, platform: PLATFORM }, { needToken: false, ...config })
  }

  /**
   * 获取直播详情
   */
  static getLiveInfo(payload: { id: string }, config?: Config) {
    return this.get(index.LIVE_INFO, payload, config)
  }

  /**
   * 获取游戏记录
   */
  static getGameRecord(payload: {}, config?: Config) {
    return this.get(index.GAME_RECORD, payload, config)
  }

  /**
   * 获取游戏记录(分页)
   */
  static getGameRecordV2(payload: { page: 1 }, config?: Config) {
    return this.get(index.GAME_RECORD_V2, payload, config)
  }

  /**
   * 获取游戏详情
   * @param payload 
   * @returns 
   */
  static getGameDetail(payload = {}): Promise<ServiceReturnType[index.GAME_DETAIL]> {
    return this.get(index.GAME_DETAIL, { ...payload });
  }
}
